import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, ytKontrolaPoModulu97, ZrcComponent, NotificationService } from 'yt-ng-framework';
import { CompanyZrc } from './company-zrc';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BankaView } from 'src/app/lookups/banka/banka-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-company-zrc-update',
  templateUrl: './company-zrc-update.component.html'
})
export class CompanyZrcUpdateComponent extends BaseUpdateComponent<CompanyZrc> implements OnInit {

  @ViewChild('zrcKontrola', { static: true }) zrcKontrola: ZrcComponent;
  sifraBanke: string = null;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Zrc", Validators.required, 'required', 'FIRMAZRC.ZRC.VALIDATION.REQUIRED');
    this.addValidatorToFc("Zrc", Validators.pattern('^[0-9]{3}-[0-9]{1,13}-[0-9]{2}$'), 'pattern', 'KOMITENTZRC.ZRC.VALIDATION.PATTERN');
    this.addValidatorToFc("BankaID", Validators.required, 'required', 'COMPANYZRC.BANKA.VALIDATION.REQUIRED');
    this.baseFormGroup.setValidators(zrcControl('Zrc', this));

  }

  onBankaSelect(value: BankaView) 
  {   
    //Zrc - fromControlName kontrole kojoj dodeljujem vrednot, value.Sifra - polje iz modela BankaView
    if (value){
      if (this.Item.ID == -1)
        this.baseFormGroup.patchValue({Zrc : value.Sifra});
      
      if (value.Sifra != "999")
        this.zrcKontrola.zrc1.disabled = true;
      
      this.sifraBanke = value.Sifra;
    }   
  }
}

function zrcControl(zrcControlKey: string, mainThis: any){
  return (group: FormGroup): {[key : string]: any} =>{
      let zrcControl : string = group.controls[zrcControlKey].value;
      let value : string = null;
      if (zrcControl){
        value = zrcControl.replace(/-/g,"");
        value = value.substr(0, value.length-2);
        let kontrolniBroj : string = null;
        kontrolniBroj = zrcControl.replace(/-/g,"");
        kontrolniBroj = kontrolniBroj.substr(kontrolniBroj.length-2, 2);
        let kontrola97 : string = null;

        if (mainThis.sifraBanke != null && mainThis.sifraBanke != "999")
        {
          kontrola97 = ytKontrolaPoModulu97(value);    
          if (kontrola97 && kontrola97 != kontrolniBroj)      
          return { 
            zrcControlNumbers : {valid : false, message : 'FW.KONTROLAPOMODULU.VALIDATION.MODUL97'}
          };
          else
            return null;
        }

        else
          return null;
      }
      else 
        return null;
     
      
  }
  
}

function ZrcKontrola(zrcKey:string){
  return (group: FormGroup): {[key : string]: any} =>{
    let zrc : string = group.controls[zrcKey].value;
    if (zrc != null){
      let zrcProvera : string = ytKontrolaPoModulu97(zrc.split('-')[0]+zrc.split('-')[1]);
      if (zrcProvera != zrc.split('-')[2])
        return { checkZrc :{valid:false, message: 'FW.KONTROLAPOMODULU.VALIDATION.MODUL97'}};
      else
        return null;
    }
  }
}
